import type { SxProps, Theme } from "@mui/material/styles";

/** White card-style surface for lists, grids, and forms (customer portal). */
export const surfacePanelSx: SxProps<Theme> = {
  bgcolor: "#ffffff",
  borderRadius: 1,
  border: 1,
  borderColor: "divider",
};

/** Form container: white panel + explicit white outlined fields (theme-safe). */
export const formSurfaceSx: SxProps<Theme> = {
  ...surfacePanelSx,
  p: 3,
  mt: 2,
  "& .MuiOutlinedInput-root": {
    bgcolor: "#ffffff",
  },
};

/** DataGrid lists in the customer portal (inside outlined Paper). */
export const portalDataGridSx: SxProps<Theme> = {
  border: "none",
  "& .MuiDataGrid-columnHeaders": {
    fontWeight: 600,
    bgcolor: "grey.50",
  },
  "& .MuiDataGrid-cell": {
    alignItems: "flex-start",
    py: 1.25,
  },
  "& .MuiDataGrid-footerContainer": {
    borderTop: 1,
    borderColor: "divider",
  },
};
